import React from "react";
import { itemTypeClass } from "../itemTypeClass";

export default function ItemCard({ item }) {
  return (
    <div className={`item-card type-${itemTypeClass(item.type)}`}>
      <div className="item-card-header">
        <span className="item-name">{item.itemName}</span>
        {item.quantity && <span className="item-quantity">×{item.quantity}</span>}
      </div>

      {item.mainImageUrl && (
        <div className="item-image-frame">
          <img
            src={item.mainImageUrl}
            alt=""
            className="item-image"
            loading="lazy"
            draggable="false"
          />
        </div>
      )}

      <div className="item-card-footer">
        <span className="item-type">{item.type}</span>
      </div>
    </div>
  );
}
